// extracted by mini-css-extract-plugin
export default {"horizontalLine":"DeleteCardModal_horizontalLine__u1ctM","message":"DeleteCardModal_message__-DOAB","titlePack":"DeleteCardModal_titlePack__OpN62"};